import React from 'react';
import RichContent from './RichContent';

function MarkdownArticle({ articleRef, children, className = '' }) {
  return (
    <RichContent articleRef={articleRef} className={className}>
      {children}
    </RichContent>
  );
}

export default MarkdownArticle;
